import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';

import { authInterceptorFn, AuthModule } from '@plugins/client/auth';
import { JsonDateModule } from '@plugins/client/json-date';
import { AdminPreloadStrategy } from '@plugins/client/routing/admin-preload-strategy';
import { providePluginsPrimeNG } from '@plugins/client/styles/primeng';
import { APP_VERSION } from '@plugins/client/tokens/app-version.token';
import { localeIdProvider } from '@plugins/client/translate/providers';
import {
  TRANSLATE_CONFIG,
  TranslateConfigToken,
} from '@plugins/client/translate/services';
import { MiddlewareSdkModule } from '@plugins/middleware-sdk';

import { environment } from '../environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(AdminPreloadStrategy),
      withComponentInputBinding(),
    ),
    provideHttpClient(withInterceptors([authInterceptorFn])),
    importProvidersFrom(MiddlewareSdkModule),
    importProvidersFrom(AuthModule.forRoot()),
    providePluginsPrimeNG(),
    importProvidersFrom(JsonDateModule.configure({ paths: ['/api/'] })),
    localeIdProvider(environment.languages),
    { provide: APP_VERSION, useValue: environment.appVersion },
    {
      provide: TRANSLATE_CONFIG,
      useValue: {
        languages: environment.languages,
        fallbackLanguage: environment.languages[0],
        useFallbackLanguageOnMissing: true,
      } satisfies TranslateConfigToken,
    },
  ],
};
